import React from "react";

import { AutocompleteItem } from "@/components/ui/Forms/AutocompleteList";
import { Filter } from "@/types/SearchFilter.types";
import SmartAutocompleteInput from "@/ui/Forms/SmartAutocompleteInput";

interface IProps {
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
  setSelectedFilters: (selectedFilters: Filter) => void;
  handleAutocompleteSelect: (item: AutocompleteItem) => void;
  clearedFilters: Filter;
  filteredAutocompleteOptions: AutocompleteItem[];
  searchInputRef: React.RefObject<HTMLInputElement | null>;
  placeholder: string;
}

const AutocompleteInputSectionForModal = ({
  searchValue,
  setSearchValue,
  clearedFilters,
  setSelectedFilters,
  handleAutocompleteSelect,
  filteredAutocompleteOptions,
  searchInputRef,
  placeholder,
}: IProps) => {
  return (
    <>
      {/* Search/Filter Input */}
      <div className="min-h-[54px] md:hidden w-full px-4 mb-4">
        <SmartAutocompleteInput
          value={searchValue}
          onChange={(val: string) => setSearchValue(val)}
          onClear={() => {
            setSearchValue("");
            setSelectedFilters(clearedFilters);
          }}
          onKeyPress={(e) => {
            const fullCoincidence = filteredAutocompleteOptions.find(
              (item) =>
                item.title.trim().toLowerCase() ===
                searchValue.trim().toLowerCase(),
            );

            if (
              e.key === "Enter" &&
              (filteredAutocompleteOptions.length === 1 || fullCoincidence)
            ) {
              handleAutocompleteSelect(
                fullCoincidence ?? filteredAutocompleteOptions[0],
              );
            }
          }}
          placeholder={placeholder}
          isOpen={false}
          inputRef={searchInputRef}
          autoFocus
        />
      </div>
    </>
  );
};

export default AutocompleteInputSectionForModal;
